<template>
    <div class="simulador_passo_pessoais">
        <form>
            <div class="row">
                <div class="col-lg-8 offset-lg-2 col-md-10 offset-md-1 col-sm-12 col-xs-12">
                    <div class="input-group">
                        <label>Seu nome:</label>
                        <input type="text" v-model="form.nome" class='form-control'>    
                        <small class='error_message'>{{ erros.nome }}</small>
                    </div>                
                    <div class="input-group">
                        <label>Seu melhor email:</label>
                        <input type="email" v-model="form.email" class='form-control'>    
                        <small class='error_message'>{{ erros.email }}</small>
                    </div>            
                    <div class="form-row">
                        <div class='col-lg-6 col-md-6 col-sm-6 col-xs-12'>
                            <div class="input-group">
                                <label>Seu telefone com DDD:</label>
                                <input type="text" v-model="form.telefone" class='form-control' v-mask="'(##) #####-####'">    
                                <small class='error_message'>{{ erros.telefone }}</small>
                            </div>                                            
                        </div>
                        <div class='col-lg-6 col-md-6 col-sm-6 col-xs-12'>
                            <div class="input-group">
                                <label>Seu CEP:</label>
                                <input type="text" v-model="form.cep" class='form-control' v-mask="'#####-###'">    
                                <small class='error_message'>{{ erros.cep }}</small>
                            </div>                                                                
                        </div>                        
                    </div>    
                </div>
            </div>
        </form>
        <div class="form-row">
            <div class="btn_proximo">
                <button class='btn btn-secondary' @click='voltar'>Voltar</button>
                <button class='btn btn-danger' @click='proximo_passo'>Próximo passo</button>
            </div>
        </div>        
    </div>
</template>

<script>
    export default {
        data(){
            return{
                form:{
                    nome:"",
                    email:"",
                    telefone:"",
                    cep:""
                },
                erros:{
                    nome:"",
                    email:"",
                    telefone:"",
                    cep:""                    
                },
                bareta:""
            }
        },
        methods:{
            voltar(){
                this.$emit('anterior');
            },
            proximo_passo(){

                if (!this.validar()) return;
                
                this.$emit('proximo',this.form);

            },
            validar(){

                this.erros = {};

                if (this.form.nome.trim()=="") this.erros.nome = "Informe seu nome";
                if (this.form.email.trim()=="") this.erros.email = "Informe seu melhor e-mail";
                if (!this.validateEmail(this.form.email)) this.erros.email = "Informe um e-mail válido";
                if (this.form.telefone.trim()=="") this.erros.telefone = "Informe seu telefone para contato";
                if (this.form.telefone.trim().length<13) this.erros.telefone = "Informe um telefone válido";
                if (this.form.cep.trim()=="") this.erros.cep = "Informe seu cep";
                if (this.form.cep.trim().length!=9) this.erros.cep = "Informe um cep válido";

                if (Object.entries(this.erros).length==0 ) return true;

                return false;

            },
            validateEmail(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            }            
        },
        computed:{
            preenchido: function(){

                if (this.form.nome.trim()!="" &&
                    this.form.email.trim()!="" &&
                    this.form.telefone.trim()!="" &&
                    this.form.cep.trim()!="")
                {
                    return true;
                }
                return false;
            }

        },
        watch:{
            preenchido: function(newF,OldF){
                if (newF==true) this.$emit('can-continue',{value:true});
            }
        },
        mounted() {
            if (this.preenchido) this.$emit('can-continue',{value:true});
        }
    }
</script>
